<template>
  <div class="f-ast f-v">
    <donut-modal-sections-title title="Redeem Gift Card" />
    <div class="flex">
      <div class="f-v f-gap-8 w-max-60p p-14" style="white-space: pre-line; line-height: 1.5;">
        <div v-emoji="selectorLabel" class="t" />
      </div>
      <div class="f-v f-auto p-14" style="flex: auto;">
        <donut-selector-single-static
          :options="giftCardValueOptions"
          :model-value="selectedGiftCardOption"
          :update-function="selectGiftCardValue"
        />
      </div>
    </div>
    <donut-modal-sections-actions
      button-text="Continue"
      save-mutation="updateModal"
      :save-args="saveArgs"
      :is-save-disabled="selectedGiftCardOption.disabled"
    />
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const listing = computed(() => state.modal.data.listing);
  const config = computed(() => state.pointsConfig.config);
  const pointsWallet = computed(() => state.rewardsListings.pointsWallet);

  const selectorLabel = computed(() => `Choose your gift card value
    ${pointsWallet.value.current_redeemable.toLocaleString()} :${config.value.emoji}: available`);

  const giftCardValueOptions = computed(() => (
    listing.value.gift_card_options.map(({ points, dollars, affordable }) => ({
      label: `$${dollars.toLocaleString()} (${points.toLocaleString()} :${config.value.emoji}:)`,
      value: points,
      formatEmojis: true,
      disabled: !affordable || points > pointsWallet.value.current_redeemable,
    }))
  ));

  const defaultGiftCardValue = computed(() => {
    const affordableOptions = giftCardValueOptions.value.filter(option => !option.disabled);

    return affordableOptions.length > 0
      ? affordableOptions[affordableOptions.length - 1] // Highest affordable option
      : giftCardValueOptions.value[0]; // Default to lowest option if none affordable
  });

  const selectedGiftCardOption = ref(defaultGiftCardValue.value);

  const selectGiftCardValue = (value) => {
    selectedGiftCardOption.value = value;
  };

  const saveArgs = computed(() => ({
    visible: true,
    subcomponent: 'shoutouts-rewards-modals-confirm-gift-card-redemption',
    data: {
      listing: listing.value,
      gift_card_points_cost: selectedGiftCardOption.value.value,
    },
  }));
</script>
